module.exports = __webpack_public_path__ + "static/media/globe.acf12ca3.svg";